const SocialIconYoutube = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1308 4.20604C15.3795 4.45643 15.5587 4.76797 15.6508 5.10971C15.99 6.3713 16 8.98788 16 8.98788C16 8.98788 16 11.6148 15.6613 12.8663C15.5692 13.208 15.39 13.5196 15.1413 13.77C14.8927 14.0203 14.5834 14.2009 14.244 14.2935C13.0013 14.6349 8 14.6349 8 14.6349C8 14.6349 2.99875 14.6349 1.75625 14.2933C1.4169 14.2006 1.10754 14.0201 0.858913 13.7697C0.610285 13.5193 0.431044 13.2078 0.339 12.866C0 11.6045 0 8.98788 0 8.98788C0 8.98788 0 6.3713 0.32875 5.11978C0.420794 4.77804 0.600035 4.4665 0.848663 4.21611C1.09729 3.96573 1.40665 3.78523 1.746 3.69253C2.98875 3.35089 7.99 3.34082 7.99 3.34082C7.99 3.34082 12.991 3.34082 14.2335 3.68246C14.5729 3.77516 14.8822 3.95566 15.1308 4.20604ZM10.547 8.98871L6.39823 11.4087L6.39798 6.56876L10.547 8.98871Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconYoutube };
